import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import { Toaster } from 'sonner';
import Routing from './routes';
import ErrorBoundary from './ErrorBoundary';

console.error = () => {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <ErrorBoundary>
    <Routing />
    <Toaster richColors />
  </ErrorBoundary>
  </>
);